import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "fixed bottom-0 left-0 right-0 bg-white p-4 lg:p-0 lg:static max-w-[666px] flex items-center md:justify-end shadow-md lg:shadow-none lg:bg-transparent" }
const _hoisted_2 = { class: "add-to-cart-button-price" }


export default {
  __name: 'AddToCartButton',
  props: {
    price: {
        type: String,
        required: true,
    },
    isSubmitting: {
        type: Boolean,
        required: true,
    },
},
  setup(__props) {

const props = __props;



return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: _normalizeClass(["Button--no-style add-to-cart-button", {
                'is-submitting': __props.isSubmitting,
            }])
    }, [
      _createTextVNode(_toDisplayString(__props.isSubmitting ? 'Procesowanie...' : 'Płatność') + " ", 1),
      _createElementVNode("span", _hoisted_2, _toDisplayString(__props.price) + " zł", 1)
    ], 2)
  ]))
}
}

}